var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaynow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3789 17.4309L22.198 9.13258C21.8947 6.99842 20.0639 5.41675 17.908 5.41675H8.09304C5.9372 5.41675 4.10637 6.99842 3.80304 9.13258L2.62221 17.4309C2.38387 19.0992 3.67304 20.5834 5.35221 20.5834C6.08887 20.5834 6.7822 20.2909 7.3022 19.7709L9.75054 17.3334H16.2505L18.688 19.7709C19.208 20.2909 19.9122 20.5834 20.638 20.5834C22.328 20.5834 23.6172 19.0992 23.3789 17.4309ZM21.1039 18.2109C21.0172 18.3084 20.8764 18.4167 20.6489 18.4167C20.4864 18.4167 20.3347 18.3517 20.2264 18.2434L17.1497 15.1667H8.85137L5.77471 18.2434C5.66637 18.3517 5.51471 18.4167 5.35221 18.4167C5.12471 18.4167 4.98387 18.3084 4.89721 18.2109C4.81054 18.1134 4.72387 17.9617 4.75637 17.7342L5.93721 9.43591C6.09971 8.38508 7.02054 7.58341 8.09304 7.58341H17.908C18.9805 7.58341 19.9014 8.38508 20.053 9.44675L21.2339 17.7451C21.2664 17.9617 21.1797 18.1134 21.1039 18.2109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.66675H8.66667V10.8334H6.5V11.9167H8.66667V14.0834H9.75V11.9167H11.9167V10.8334H9.75V8.66675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4173 14.0834C19.0156 14.0834 19.5007 13.5984 19.5007 13.0001C19.5007 12.4018 19.0156 11.9167 18.4173 11.9167C17.819 11.9167 17.334 12.4018 17.334 13.0001C17.334 13.5984 17.819 14.0834 18.4173 14.0834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2513 10.8334C16.8496 10.8334 17.3346 10.3484 17.3346 9.75008C17.3346 9.15177 16.8496 8.66675 16.2513 8.66675C15.653 8.66675 15.168 9.15177 15.168 9.75008C15.168 10.3484 15.653 10.8334 16.2513 10.8334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_256_516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaynow);
export default __webpack_public_path__ + "static/media/playnow.0db9a09c8b5c144fdc9ac38e6ff5311f.svg";
export { ForwardRef as ReactComponent };